import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const TechnologyPage = lazy(() => import('../pages/technology/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/technology',
    element: <TechnologyPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
